import {HTTP_RESPONSE_STATUS} from 'setup/constants/Http'
import {ServiceLevel} from '../models'
import {ServiceManagementApi} from '../redux/ServiceManagementApi'

export interface InheritedDuration {
  minutes: number
  fromLevel: ServiceLevel
}

// Nearest ancestor first, the same order as the backend's resolve chain (Sub-Sub → Sub → Major).
// Calls the API directly: the getCentroServiceConfig saga is takeLatest, so dispatching here
// would cancel the form's own config request.
export const fetchInheritedDuration = async (
  categoryInfoId: string,
  ancestors: {serviceLevel: ServiceLevel; serviceId?: number}[]
): Promise<InheritedDuration | null> => {
  for (const {serviceLevel, serviceId} of ancestors) {
    if (serviceId === undefined || !Number.isFinite(Number(serviceId))) continue

    const response = await ServiceManagementApi.getCentroServiceConfig({
      serviceLevel,
      serviceId: Number(serviceId),
      categoryInfoId,
    })
    if (response.status !== HTTP_RESPONSE_STATUS.SUCCESS) return null

    const minutes = response.data?.duration
    if (minutes != null) return {minutes, fromLevel: serviceLevel}
  }
  return null
}
